/* eslint-disable */
import React from "react";
import { Switch, Tooltip, Loader } from "@mantine/core";
import type { SwitchProps } from "@mantine/core";
import { useHasPermission } from "./useHasPermission";

type PermissionSwitchProps = SwitchProps & {
  permission: string;
  hideIfNo?: boolean;
  tooltipIfNo?: string;
};

export const PermissionSwitch: React.FC<PermissionSwitchProps> = ({
  permission,
  hideIfNo = false,
  tooltipIfNo = "You don't have permission",
  onChange,
  ...rest
}) => {
  const { has, isLoading } = useHasPermission(permission);

  if (isLoading) {
    return (
      <div style={{ display: "inline-flex", alignItems: "center" }}>
        <Switch disabled {...rest} />
        <div style={{ marginLeft: 8 }}>
          <Loader size="xs" />
        </div>
      </div>
    );
  }

  if (!has) {
    if (hideIfNo) return null;

    return (
      <Tooltip label={tooltipIfNo} withArrow>
        <div style={{ display: "inline-block", cursor: "not-allowed" }}>
          <Switch disabled {...rest} />
        </div>
      </Tooltip>
    );
  }

  return <Switch onChange={onChange} {...rest} />;
};

export default PermissionSwitch;
